// @flow
import React from 'react';
import { SelectButton } from '../SelectButtons';

type LocationProps = {
  id: number,
  name: string,
  onClick: Function,
  selected: boolean
};

export const LocationOption = ({ id, name, onClick, selected }: LocationProps) => {
  const handleClick = () => onClick(null, id);

  return (
    <SelectButton hideMobile onClick={handleClick} selected={selected}>
      {name}
    </SelectButton>
  );
};
